var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title || _vm.body)?_c('div',{},[(_vm.title)?_c('h6',{staticClass:"text-grey-10"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.body)?_c('p',{class:{ 'q-pt-sm': _vm.title }},[_vm._v(_vm._s(_vm.body))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }